module.exports = __webpack_public_path__ + "img/76800.32e991cc.jpg";